import React from "react";

import { Icon } from "@components/Icon/Icon";
import arrowIcon from "@svg-icons/arrow.component.svg";
import styles from "./styles.module.scss";
import classnames from "classnames";
export interface LinkProps extends React.ComponentPropsWithoutRef<"a"> {
  icon?: boolean;
}

const Link: React.FC<LinkProps> = ({
  href,
  children,
  className,
  icon,
  target,
  ...props
}) => (
  <a
    href={href}
    target={target}
    className={classnames(className, icon && styles.iconLink)}
    {...props}
  >
    <>
      {children}
      {icon && <Icon svg={arrowIcon} className={styles.icon} />}
    </>
  </a>
);

Link.defaultProps = {};

export { Link };
